<template>
  <svg class="brand-mark" viewBox="0 0 44 44" fill="none" aria-hidden="true">
    <path d="M7.5 15.2 6 6.5c-.2-1.3 1.2-2.1 2.3-1.5l8.5 4.5a21 21 0 0 1 10.4 0l8.5-4.5c1.1-.6 2.5.2 2.3 1.5l-1.5 8.7c2 2.4 3 5.3 3 8.6 0 9.1-7.8 15.5-17.5 15.5S4.5 32.9 4.5 23.8c0-3.3 1-6.2 3-8.6Z" fill="currentColor"/>
    <path d="M15.3 23.4c1.2 0 2.2-1 2.2-2.2S16.5 19 15.3 19s-2.2 1-2.2 2.2 1 2.2 2.2 2.2Zm13.4 0c1.2 0 2.2-1 2.2-2.2S29.9 19 28.7 19s-2.2 1-2.2 2.2 1 2.2 2.2 2.2Z" fill="white"/>
    <path d="M20 28.4c1.3 1.2 2.7 1.2 4 0m-2-1.4v2.4m-10.5-2.2-3.3 1m24.3-1 3.3 1" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>
